module.exports = __webpack_public_path__ + "img/functions_inactive.899ce138.svg";